module.exports = __webpack_public_path__ + "static/media/Fontfabric - MullerHairlineItalic.9d4634b5.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/Fontfabric - MullerHairlineItalic.otf
// module id = 1065
// module chunks = 0